export const classes = {
  background:
    'absolute inset-0 overflow-hidden bg-blue-500/30 bg-cover bg-no-repeat dark:bg-none dark:bg-[#1a1620]',
  blob: 'absolute rounded-full blur-3xl',
  skyBlob: 'top-0 left-[10%] size-96 bg-blue-300/80 dark:bg-blue-300/50',
  purpleBlob:
    'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 size-[600px] bg-purple-300/60 dark:bg-purple-300/40',
  blueBlob: 'bottom-0 right-1/4 size-96 bg-blue-200 dark:bg-blue-200/50',
  greenBlob: 'top-0 right-0 size-[600px] bg-blue-1/60 dark:bg-blue-1/40',
};

export const styles = {
  blob: (animation: string) => ({
    animation: `${animation} 10s infinite`,
  }),
};

// eslint-disable-next-line no-restricted-syntax
export const BLOBS = [
  [classes.skyBlob, styles.blob('orange-blob-warp')],
  [classes.purpleBlob, styles.blob('purple-blob-warp')],
  [classes.blueBlob, styles.blob('blue-blob-warp')],
  [classes.greenBlob, styles.blob('green-blob-warp')],
] as const;
